import styled from 'styled-components';
import { Icon } from './Icon';

export const AddressIcon = styled(Icon)`
    &:before {
        content: '\\e7ee';
    }
`;
